const messages = {
    scanWithBankApp: "銀行アプリでスキャンしてください",
    scanWithCreditCardApp: "クレジットカードアプリでスキャンしてください",
    scanOrOpenApp: "スキャンまたはアプリを開いてお支払いを完了してください",
    scanForPayment: "スキャンしてお支払い",
    scanWithBankApp: 'お使いの銀行アプリでスキャンしてお支払い',
    changePaymentWarning: "お支払い方法を変更すると、以前のQR Codeは無効になります。新しい方法のみをご利用ください。",
    swapShop: "新しいお店に切り替えますか？<br>",
    swapShopDespt: "以前のお店で選択した商品は保存され、後で注文できます",
    sorryForInconvenient: 'ご不便をおかけして申し訳ございません',
    openAt: '営業開始時間',
    shopIsClosedToday: '本日は休業日です',
    checkOrderedItem: '注文済みの料理を確認する',
    tryAgainIn: '再試行可能時間',
    lockUserPIN: "PINを5回以上間違えました",
    lockUserPINDespt: "5分後にもう一度お試しください",
    inValidPIN: 'PINが正しくありません',
    enterPasswordToAccessMenu: "メニューにアクセスするためPINを入力してください",
    customersCanGetPasswordFromStaff: "PINはスタッフにお尋ねください",
    tableNotAvailable: "テーブルは利用できません",
    contactStaffToOpenTable: "スタッフに連絡してテーブルを開けてください",
    outOfRestaurantRange: "レストランの範囲外です",
    phoneIsMoreThan100MetersAwayFromRestaurant: "お使いの携帯電話はレストランから100メートル以上離れています",
    restaurantIsCurrentlyClosed: "レストランは現在閉店しています",
    restaurantOpenHours: "キッチンの営業時間",
    packingSize: 'パッケージサイズ',
    shippingDelivery: '配送',
    waitForPaymentDelivery: '支払い待ち',
    readyForPcikup: '受取準備完了',
    noNotifyNow: "現在通知はありません",
    noNotifyNowDespt: "サービスを利用すると、通知がここに表示されます",
    newAddressDespt: "配達をスムーズにするため、正しい目的地をピンして位置情報へのアクセスを許可してください",
    deleteAddressSuccess: '住所を削除しました',
    createProfileSuccess: "プロフィールを作成しました",
    ex: '例',
    receiverName: '受取人名',
    editAddress: '住所を編集',
    nameInputInvalid: '名前が正しくありません',
    openInGoogleMap: 'Google Mapで開く',
    pleaseSelectPaymentMethod: 'お支払い方法を選択してください',
    noDeliveryAddress: '配送先住所がありません',
    noDeliveryAddressDespt: '配送先住所情報を追加してください',
    deliveryType: '配達',
    pickupType: 'テイクアウト',
    shopIsClose: '閉店中',
    openingHoursDespt: '営業時間',
    contactShop: 'お店に連絡',
    pickupAtShop: 'テイクアウト',
    thanksForOrderingDespt: 'ご利用ありがとうございます。<br>またのお越しをお待ちしております！',
    deliveredSuccess: '配達完了',
    expireIn: '有効期限',
    waitForPayment: '支払い待ち',
    waitForPaymentDespt: "お支払い確認をお待ちください。<br>まだお支払いがお済みでない場合は、注文がキャンセルされないよう、指定された時間内にお支払いを完了してください。",
    newOrderIn: '新規',
    inputRequestDetails: 'リクエストの詳細を入力',
    notification: '通知',
    noticeIfOrderReady: '注文の準備ができましたらお知らせします',
    orderIsReady: 'ご注文の準備ができました',
    thanksForOrdering: 'ご利用ありがとうございます',
    toPay: 'お支払い',
    letOrder: 'メニューページに移動して注文を始めましょう',
    noTransaction: '取引なし',
    menulists: 'メニュー一覧',
    editPersonalDetails: '詳細を編集',
    trackOrder: '注文追跡',
    myAccount: 'マイアカウント',
    cart: 'カート',
    helpCenter: 'ヘルプセンター',
    allPurchaseHistory: '購入履歴',
    purchaseHistory: '購入履歴',
    personalInfo: '個人情報',
    cutlery: 'カトラリー',
    km: 'km',
    totalAmountSum: '合計',
    selectedItemList: '選択した商品',
    iAm: '私は',
    orderedBy: '注文者',
    shareQRtoFriend: 'QR Codeを共有',
    share: '共有',
    hasItemInBasket: 'カゴに商品があります',
    hasItemInBasketDespt: 'キッチンへの送信をお忘れなく',
    updatedAtQR: '更新日時',
    orderSent: '注文をキッチンに送信しました',
    orderSentDespt: 'レストランがお料理を準備中です',
    checkGramdTotalIn: '合計金額はこちらで確認できます',
    vatNotInclude: 'この価格には税金、サービス料、割引は含まれていません',
    accept: '同意する',
    termOfService: '利用規約',
    onPending: '保留中',
    OnSuccessOrder: '完了',
    prepareingOrder: '注文準備中',
    deliveringOrder: '配達中',
    pickupOrderReady: '受取準備完了',
    pickedupOrder: '受取済み',
    deliveredOrder: '配達完了',
    shopReceivedOrder: 'お店が注文を受け取りました',
    orderId: '注文ID',
    orderDetails: '注文詳細',
    deliveryFee: '配送料',
    searchDriver: 'ドライバーを検索中',
    driverFrom: 'ドライバー',
    change: '変更',
    deliveryAddress: '配送先住所',
    location: '場所',
    addressName: '住所名',
    addressNameDespt: '例：マンション名、住宅地名',
    addressDescription: '住所詳細',
    addressDescriptionDespt: '例：建物番号、路地',
    noteToDriver: 'ドライバーへのメモ',
    noteToDriverDespt: '例：入り口のテーブルに置いてください',
    inputAddressForm: '配送先住所を入力',
    plsPinAddress: '場所をピンしてください',
    pinLocation: '配達場所をピン',
    createNewAddress: '新しい住所を作成',
    savedAddress: '保存済みの住所',
    phoneNumber: '電話番号',
    noRequired: '任意',
    resendCode: 'コードを再送信',
    didNotGetCode: 'コードが届きませんか？',
    resendIn: '再送信まで',
    next: '次へ',
    createAccount: 'アカウント作成',
    createAccountDespt: 'アカウントを作成するには以下のフォームに入力してください',
    sendCodeViaSMS: 'SMSでコードを送信',
    inputOTP: 'OTPを入力',
    inputOTPDespt: '送信された6桁のコードを入力してください',
    termAndPolicy: '利用規約とポリシー',
    termAndPolicy1: 'サービスをご利用いただくことで、以下に同意したものとみなされます',
    termAndPolicy2: '利用規約とポリシーの全文を読むにはクリックしてください',

    loginWithPhoneNumber: '電話番号でログイン',
    loginWithPhoneNumberDespt: '本人確認のためOTPを受け取る電話番号を入力してください',
    backToOrder: 'メニューに戻る',
    PaymentMethod: 'お支払い',
    paymentAmount: 'お支払い金額',
    paymentConfirmation: 'お支払い確認',
    cancelPayment: '支払いをキャンセル',
    paidSuccess: 'お支払い完了',
    haveNotPurchased: 'まだ購入されていません',
    haveNotPurchased2: 'お支払いに失敗した場合はスタッフにお問い合わせください',
    canNotOrderItem: 'お支払い処理中は注文できません',
    checkPaymentStatus: 'ステータスを確認',
    pendingPayment: '支払い保留中',
    askForReceipt: '領収書が必要な場合はスタッフにお申し付けください',
    paymentSuccess: 'お支払い成功',
    summaryPayment: '概要',
    numberOfGuest: 'お客様人数',
    closeTab: '閉じる',
    addCredit: 'クレジットカードを追加',
    QRPayment: 'QR決済',
    cardPayment: 'クレジットカード',
    payWithStaff: 'レジでお支払い',
    selectPaymentMethod: 'お支払い方法を選択',
    checkOut: '会計',
    startOrderBeforeCallStaff: 'スタッフを呼ぶ前に注文してください',
    basket: 'バスケット',
    spoon: 'カトラリーをリクエスト',
    knife: 'ナイフをリクエスト',
    chopstick: 'お箸をリクエスト',
    cup: 'カップをリクエスト',
    plate: 'お皿をリクエスト',
    glass: 'グラスをリクエスト',
    payBill: 'お会計をリクエスト',
    viewAll: 'すべて表示',
    recommendMenu: 'おすすめ',
    OnSuccess: '完了',
    OnPreparing: '準備中',
    messageSent: 'スタッフをお待ちください',
    outOfStock: '在庫切れ',
    QRCode: 'QR Code',
    GenerateQRCode: 'QR Code生成',
    ForQROrder: '料理の注文と店内サービスのリクエスト用',
    QROrderDescription: 'お客様が料理の注文や店内サービスのリクエストをスキャンできるQR Codeを生成できます',
    SelectTable: 'テーブルを選択し、お客様の人数を入力してください。',
    shopname: '店舗名',
    numberOfCustomer: 'お客様の人数（人）',
    numberOfCustomerDescription: 'お客様の人数を入力してください、最低1人',
    currentUser: 'ユーザー',
    guest: 'ゲスト',
    orderItem: '注文概要',
    orderItemNav: '注文概要',
    callStaff: 'スタッフを呼ぶ',
    callStaffDialog: 'どのようなサポートが必要ですか？',
    cutlery: 'カトラリーをリクエスト',
    seasoning: '調味料をリクエスト',
    refillDrink: 'ドリンクのおかわりをリクエスト',
    other: 'その他',
    tableNumber: 'テーブル',
    menuList: 'メニュー',
    selectedItem: '料理を注文',
    selectedItemNav: '料理を注文',
    checkOrderBeforeConfirm: 'レストランに送信する前に注文内容と合計を確認してください',
    checkOrderBeforeConfirm2: '',
    startOrder: '注文開始',
    foodCategory: 'カテゴリー',
    searchByName: '商品名で検索...',
    noPreduct: '商品がありません',
    noSelectedProduct: '選択された商品がありません',
    noSelectedProductDespt: '商品を選択すると、選択リストがこのページに表示されます',
    backToMenu: 'メニューへ',
    removeSelected: 'この商品を削除しますか？',
    confirmOrder: '注文を送信',
    endOfTransection: '取引終了',
    endOfTransectionDialog: '使用上の問題がある場合は、スタッフにお問い合わせください',
    note: 'メモ',
    orderTime: '注文時間',
    orderMoreFood: 'メインメニューに戻る',
    orderPreparing: 'シェフがお料理を準備中です。少々お待ちください。まもなくお届けします',
    orderPreparing2: '',
    sendingOrder: 'キッチンに注文を送信中...',
    login: 'ログイン',
    forgetPassword: 'パスワードを忘れた',
    loginWithGmail: 'Gmailでログイン',
    or: 'または',
    loginAsStaff: 'スタッフとしてログイン',
    billOrder: '伝票',
    table: 'テーブル',
    billOrderDialog: 'QR Codeをスキャンしてメニューを見て注文してください',
    billOrderDialog2: '使用上の問題がある場合は、スタッフにお問い合わせください',
    selectTableAleart: 'QR Codeを生成する前にテーブルを選択してください',
    emptyCartDialog: '取引なし',
    emptyCartDialogDespt: '注文を確定すると、注文した商品のリストがこのページに表示されます',
    served: '提供済み',
    contactOurStaff: 'スタッフに連絡',
    contactOurStaff2: 'サポートが必要な場合',
    addToCart: 'カートに追加',
    noteToShop: 'お店へのメモ',
    addYourRequest: 'リクエストを追加',
    branchName: '支店名',
    businessType: '業種',
    taxID: '税務ID',
    vat: '税金',
    exclusive: '税抜',
    inclusive: '税込',
    serviceCharge: 'サービス料',
    address: '住所',
    address1: '住所1',
    address2: '住所2',
    tel: '電話',
    businessType1: '一般',
    businessType2: 'レストラン',
    businessType3: 'ホステル',
    shopopen: '営業 - 閉店',
    open: '営業中',
    closed: '閉店',
    languagetxt: '言語',
    language: '言語とタイムゾーン',
    languageTH: 'タイ語',
    languageEN: '英語',
    setting: '設定',
    shop: '店舗',
    timezone: 'タイムゾーン',
    deliveryProviders: '配送業者',
    adddeliveryProviders: '業者を追加',
    lastUpdate: '最終更新',
    logo: 'ロゴ',
    updateData: 'データを更新',
    submit: '送信',
    cancel: 'キャンセル',
    normal: '通常',
    loading: '読み込み中...',
    editing: '編集中',
    confirmUpdate: 'データを更新しますか？',
    selectedShoptype: '業種を選択...',
    selectshop: '支店名を選択',
    save: '保存',
    reporttxt: 'レポート',
    general: '一般',
    signOut: 'ログアウト',
    registration: '',
    unit: '単位',
    category: 'カテゴリー',
    product: '商品',
    export: 'エクスポート',
    exportKBank: 'K-Bankエクスポート',
    date: '日付',
    to: 'まで',
    status: 'ステータス',
    vatAmount: '税金',
    netTotalNonVAT: '合計（税抜）',
    receiptNumber: 'レシート番号',
    grandTotal: '総合計',
    netAmountVATTotal: '小計',
    netTotalIncVAT: '合計（税込）',
    proofOfPayment: '支払い証明',
    paymentType: '支払い方法',
    paymentType0: '現金',
    paymentType1: 'クレジットカード',
    paymentType2: 'クーポン',
    paymentType3: 'Quickpay',
    paymentType4: 'Promptpay',
    paymentType5: 'Alipay',
    paymentType6: 'デポジット',
    paymentType7: '配達',
    paymentType8: 'オンライン',
    paymentType9: 'Line Pay',
    paymentType10: 'カスタム決済',
    paymentType12: 'KBank',
    paid: '支払い金額',
    sentSuccessfully: '送信完了',
    pluCode: 'バーコード',
    netAmount: '純合計',
    discount: '割引',
    timeOfOrder: '注文時刻',
    orderDate: '注文日',
    preparing: '準備中',
    paymentDetail: '支払い詳細',
    orderNumber: '注文番号',
    delivered: '期限',
    deliveredDate: 'リードタイム',
    payment: '支払い',
    productName: '商品名',
    quantity: '数量',
    priceUnit: '単価',
    baht: 'バーツ',
    profit: '利益',
    sales: '売上',
    billAmount: '請求合計',
    total: '合計',
    bill: '伝票',
    discountAmount: '割引額',
    averageBill: '平均/伝票',
    voidbillTotal: '無効伝票合計',
    salesByDaily: '日別売上',
    salesByMonth: '月別売上',
    bestSellers: '売れ筋商品',
    bestSellerstype: '売れ筋カテゴリー',
    salesBydate: '日付別売上',
    number: '番号',
    categoryName: 'カテゴリー名',
    newOrder: '注文送信',
    reject: '拒否',
    inProgressTime: '処理時間',
    rejectTime: '拒否時間',
    cancelTime: 'キャンセル時間',
    cause: '原因',
    preparingToShip: '準備中',
    totalAmount: '合計',
    order: '注文',
    deposit: 'デポジット',
    billSave: '保存',
    ReceivingOrder: 'テーブル開設/注文受付',
    orderNo: '注文番号',
    remark: '備考',
    receiptStatus: 'レシートステータス',
    back: '戻る',
    detail: '詳細',
    countSales: '数量',
    onhandQty: '在庫数',
    stdCost: '原価',
    employees: '従業員',
    employeesname: '従業員名',
    salesTotal: '売上合計',
    totalBill: '全伝票数',
    billActive: '販売伝票数',
    billVoice: 'キャンセル伝票数',
    billDeposit: 'デポジット伝票数',
    discountItem: '商品割引合計',
    billDiscountAmount: '伝票割引合計',
    billDiscount: '割引伝票数',
    payTotal: '支払い合計',
    deliveryProvider: '配送業者',
    deliveryDetail: '配送詳細',
    customDetail: 'カスタム支払い詳細',
    customPaymentName: 'カスタム支払い名',
    firstInvoiceNO: '最初の伝票番号',
    lastInvoiceNO: '最後の伝票番号',
    roundNo: 'ラウンド番号',
    closeAt: '閉店時間',
    closeBy: '閉店者',
    totalCashSales: '現金売上合計',
    initialChange: '初期つり銭',
    totalCashIn: '入金合計',
    totalCashOut: '出金合計',
    actualInDrawer: 'ドロワー内実際金額',
    expectedInDrawer: 'ドロワー内予想金額',
    difference: '差額',
    voidBillDetail: '無効伝票詳細',
    cancelBy: 'キャンセル者',
    cancelDate: 'キャンセル日',
    searchByEmployees: '従業員で検索',
    search: '検索',
    timeIn: '出勤',
    timeOut: '退勤',
    time: '時間',
    hours: '時間',
    seconds: '秒',
    netTotal: '合計',
    reason: '理由',
    searchByProduct: '商品で検索',
    sortBy: '並び替え',
    last: '最新',
    price: '商品価格',
    sortByNumMin: '最低価格',
    sortByNumMax: '最高価格',
    documentNo: '伝票番号',
    transactionType: '取引タイプ',
    updatedBy: '更新者',
    transactionType1: '販売',
    transactionType2: '返金',
    transactionType3: '入庫',
    transactionType4: '出庫',
    transactionType5: '在庫調整（増）',
    transactionType6: '在庫調整（減）',
    transactionType7: 'ポイント交換',
    transactionType8: '入庫削除',
    transactionType9: '出庫削除',
    transactionType10: '入庫編集',
    transactionType11: '出庫編集',
    billNo: '伝票番号',
    docTotal: '合計',
    customer: 'お客様',
    username: 'ユーザー名',
    dateOfBill: '伝票日付',
    selectDate: '日付を選択',
    dialogSelectCategory: '検索するカテゴリーを選択してください',
    dialogUpdateDocumentSuccess: '伝票を更新しました',
    dialogfound: '入力された情報が正しくありません。',
    isVatIncluded: 'VAT込みですか',
    vatIccludes: 'VAT',
    confirmStock: '在庫を確認',
    confirm: '確認',
    deleteDoc: '伝票を削除',
    confirmUpdateDocModal: '在庫伝票を更新しますか？',
    confirmSaveDoc: '伝票保存の確認',
    confirmDeleteDoc: '伝票削除の確認',
    confirmDeleteModal: '在庫伝票を削除しますか？',
    dialogSaveDocumentSuccess: '伝票を保存しました',
    createStockIn: '入庫を作成',
    confirmSaveDocModal: '在庫伝票を保存しますか？',
    selectShopPlease: '店舗を選択してください',
    selectProductPlease: '商品を選択してください',
    duplicateProduct: 'この商品は既に選択されています。',
    productInvilid: '選択した商品は無効です。システム管理者にお問い合わせください。',
    confirmStockOut: '出庫を確認',
    dialogSaveDocumentOutSuccess: '伝票を保存しました',
    confirmSaveDocStockOutModal: '出庫伝票を保存しますか？',
    adjustDocType: '調整伝票タイプ',
    adjustDocType1: '増加',
    adjustDocType2: '減少',
    beforeAdjust: '在庫調整前',
    afterAdjust: '在庫調整後',
    adjust: '在庫調整',
    createDoucument: '伝票を作成',
    transferType: '移動タイプ',
    transferType1: '入庫移動',
    transferType2: '出庫移動',
    new: '新規',
    finish: '完了',
    refDocument: '参照伝票',
    statusDoc: '伝票ステータス',
    dialogSaveTransferDocumentSuccess: '移動伝票を作成しました',
    destinationShop: '送り先店舗',
    destinationShopBranch: '送り先支店',
    sourceBranch: '送り元支店',
    sourceShop: '送り元店舗',
    sourceAddress: '送り元住所',
    destinationAddress: '送り先住所',
    saveTransfer: '在庫移動を保存',
    confirmSaveTransfer: '在庫移動を保存しますか？',
    savinserviceChargegDoc: '伝票を保存中',
    selectdestinationPlease: '送り先支店を選択してください',
    validatedestinationproduct: "送り先支店にはこの商品がありません",
    validateProduct: '商品を選択してください',
    created_by: '作成者',
    receive: '受取',
    updateDoc: '伝票を更新',
    cancelDoc: '伝票をキャンセル',
    confirmCancelDoc: 'この伝票をキャンセルしますか？',
    cancelingDoc: '伝票をキャンセル中',
    updatingDoc: '伝票を更新中',
    updateDocFail: "伝票を更新できません",
    cancelDocSuccess: '伝票をキャンセルしました',
    cancelDocFail: "伝票をキャンセルできません",
    refDocumentTransfer: '参照伝票',
    comfrimTransferIn: '入庫移動を確認',
    dilogcomfrimTransferIn: '入庫移動伝票を実行しますか？',
    transferInDetail: '在庫移動詳細',
    totalNet: '純合計',
    confirmAdjust: '在庫調整を確認',
    createStockOut: '出庫を作成',
    favorite: 'お気に入り',
    isOnScreen: '画面に表示',
    negotiatePrice: '価格交渉',
    productTypeP: '一般商品',
    productTypeBOM: '部品表',
    productTypeSN: 'シリアル商品',
    productTypeSV: 'サービス（在庫なし）',
    productPLU: 'その他のパッケージサイズ',
    productBOM: '部品',
    productSN: 'Serial Number',
    morePrice: 'その他の価格',
    cost: '原価',
    quantityPrice: '数量',
    exceedUc: '価格',
    changeImg: '画像を変更',
    addProduct: '商品を追加',
    selectImg: '画像を選択',
    deleteImg: '画像を削除',
    selectImgFromPC: 'PCから画像を選択',
    confirmSaveImgDialog: '商品を保存しますか？',
    confirmSaveImg: '商品の保存を確認',
    addPrice: '価格を追加',
    editPrice: '価格を編集',
    dialigDeleteProduct: '商品を削除しますか？',
    confirmDeleteProduct: 'この商品の削除を確認',
    productType: '商品タイプ',
    countProduct: '商品数',
    addUnit: '単位を追加',
    editUnit: '単位を編集',
    active: '有効',
    inactive: '無効',
    confirmSaveUnitDialog: '単位を保存しますか？',
    confirmSaveUnit: 'この単位の保存を確認',
    dialigDeleteUnit: '単位を削除しますか？',
    confirmDeletUnit: 'この単位の削除を確認',
    confirmSaveCategoryDialog: 'カテゴリーを保存しますか？',
    confirmSaveCategory: 'このカテゴリーの保存を確認',
    dialigDeleteCategory: 'カテゴリーを削除しますか？',
    confirmDeletCategory: 'カテゴリーの削除を確認',
    addCategory: 'カテゴリーを追加',
    editCategory: 'カテゴリーを編集',
    bgColor: '背景色',
    selectbgColor: '背景色を選択',
    validateCategoryname: 'カテゴリー名を入力してください。',
    sequence: '順序',
    enterProduct: '商品名を入力してください。',
    enterPrice: '商品価格を入力してください。',
    selectCategory: '商品カテゴリーを選択してください。',
    selectUnit: '商品単位を選択してください。',
    confirmSaveProduct: 'この商品を保存しますか？',
    confirmSaveProductPrice: '他の価格を保存しますか？',
    validatepackQty: '単価を入力してください。',
    validatepackUc: '価格を入力してください。',
    validatePRU: 'データが重複しています。再入力してください。',
    createProductSuccess: '商品を作成しました',
    addSerial: 'シリアルを追加',
    add: '追加',
    createSerial: 'Serial Number生成',
    available: '販売可能',
    soldOut: '売り切れ',
    deleteSuccess: '削除しました',
    enterSerial: 'Serial Numberを入力してください',
    confirmSaveSerial: 'このSerial Numberを保存しますか？',
    confirmDelete: 'このSerial Numberを削除しますか？',
    addProductPLU: 'パッケージサイズを追加',
    img: '画像',
    SKURatio: '比率',
    editProductPLU: 'パッケージサイズを編集',
    enterSKURatio: '比率を入力してください',
    comfrimDeletePLU: 'このパッケージサイズを削除しますか？',
    useStepPrice: '段階価格を使用',
    addBOM: '部品を追加',
    confirmSaveBOM: '部品を保存しますか？',
    user: 'ユーザー',
    userDetail: 'ユーザー詳細',
    planDetail: 'プラン詳細',
    currentPlan: '現在のプラン',
    expireDate: '有効期限',
    startDate: '開始日',
    dialogSignOut: 'ログアウトしますか？',
    confirmSignOut: 'ログアウトの確認',
    countMember: '全メンバー',
    addMenber: 'メンバーを追加',
    searchMember: '名前、メール、電話番号で検索',
    dateOfMember: 'メンバー登録日',
    recentVisit: '最近の訪問',
    memberName: 'メンバー名',
    email: 'メール',
    paymentTotal: '支払い合計',
    point: 'ポイント',
    pointtxt: 'ポイント',
    postalCode: '郵便番号',
    saveing: '保存中...',
    edit: '編集',
    editMember: 'メンバーを編集',
    deleteing: '削除中...',
    dialogDeleteMember: 'メンバーを削除しますか？',
    confirmDeleteMember: '削除の確認',
    valtdateMember: '情報を入力してください',
    createMemberSuccess: 'メンバーを追加しました！',
    updateMemberSuccess: 'メンバーを編集しました！',
    deleteMemberSuccess: 'メンバーを削除しました！',
    onhandQtyMin: '最小在庫',
    onhandQtyMax: '最大在庫',
    onhandQtySort: '在庫数',
    showProductAll: '全商品タイプ',
    updateAt: '最終更新',
    sortName: '名前',
    stockUnit: '単価原価',
    deleteCategory: 'カテゴリーを削除',
    selectd: '選択',
    searchProduct: '商品を検索',
    reset: 'リセット',
    selectdProduct: '商品を選択',
    information: '情報',
    adjustStockList: '在庫調整商品',
    adjustDetail: '在庫調整リストに商品を追加し設定する',
    transferoutList: '在庫移動商品',
    addProductTransfer: '在庫移動リストに商品を追加し設定する',
    transferDetail: '出庫リストに商品を追加し設定する',
    transferinList: '入庫リストに商品を追加し設定する',
    stockOutList: '出庫商品',
    addstockOutList: '出庫リストに商品を追加し設定する',
    stockinList: '入庫商品',
    addProductStockin: '入庫リストに商品を追加し設定する',
    checkCount: '在庫確認',
    createAdjustStock: '在庫調整を作成',
    memberDetail: 'メンバー情報',
    package: 'パッケージ詳細',
    startPackate: 'パッケージ開始',
    endPackate: 'パッケージ終了',
    name: '名前',
    productImg: '商品画像',
    fistname: '名',
    lastname: '姓',
    saveMember: '情報を保存',
    confirmSaveMember: 'メンバーを保存しますか？',
    yesOrNo: 'はい/いいえ',
    totaValue: '合計',
    deleteMember: 'メンバーを削除',
    frequently: 'よく注文する商品',
    recentPurchase: '最後の購入',
    paymentDescription: '支払い説明',
    validateInfomation: '情報を入力してください',
    validateTel: '電話番号が正しくありません',
    validateOTP: 'OTPが正しくありません',
    validateEmail: 'メールアドレスが正しくありません',
    saveSuccess: '保存しました',
    txtcustomer: 'お客様',
    customerName: 'お客様名',
    customerCount: 'お客様数',
    addCustomer: 'お客様を追加',
    permissionManage: '権限',
    mainMenu: 'メインメニュー',
    page: 'ページ',
    show: '表示',
    delete: '削除',
    administratorTools: '管理者ツール',
    deviceName: 'デバイス名',
    lastSyncProduct: '最終同期',
    version: 'バージョン',
    posstatus: 'ステータス',
    posNumber: 'POS番号',
    titleSilomconnect: '以下のサービスで売上を見逃しません',
    updateSilom: 'LINEで日々の売上を無料で更新',
    addfriend: '友達追加',
    enterToReciveService: 'サービス利用コードを受け取るには押してください。',
    verifyCodeToUsed: 'システムの使用を開始するには、本人確認コードを受け取るために押してください。',
    verifyfivemin: '確認コードは5分間有効です。',
    yourVertify: '確認コード',
    pressCode: 'コードを受け取る',
    exCode: 'コードの有効期限',
    sessionEx: 'ログインセッションが期限切れです。再度ログインしてください。',
    refresh: '更新',
    selectedFile: 'ファイルを選択',
    fileSize: 'ファイルサイズは2MB以下にしてください。',
    isBeingToUsed: '使用中',
    notInUse: '未使用',
    delete: '削除',
    confirmUpdateInformation: '情報の更新を確認',
    memberCount: '人数',
    orderMachine: '注文デバイス',
    textMember: 'メンバー',
    manageShop: '店舗情報管理',
    lansetting: '店舗の言語とタイムゾーンを設定',
    timezoneSetiing: '店舗のタイムゾーンを設定',
    deliveryProviderSetting: '店舗の配送業者',
    toolsSetting: '店舗のPOSマシンを管理',
    checkStockPLU: '商品残高 < 0',
    searching: '検索中',
    allProduct: '全商品',
    foundProductOnhand: '在庫数 < 0 の商品が見つかりました',
    confirmAdjustBefor: 'システムで自動調整しますか？',
    requireAdjust: 'はい',
    imrequireAdjust: 'いいえ',
    islimitItemTodoc: '1伝票あたり最大200商品まで選択できます。',
    barcodePrint: 'バーコード印刷',
    printEx: '印刷＆例',
    print: '印刷',
    downloadAndExport: 'ダウンロードして印刷',
    selectFormat: '用紙サイズを選択',
    peperFormat: '用紙サイズ',
    optional: 'オプション',
    standardA427: 'A4標準：27アイテム/ページ',
    standardA450: 'A4標準：52アイテム/ページ',
    standardA460: 'A4標準：60アイテム/ページ',
    standardA556: 'A4標準：56アイテム/ページ（ステッカーサイズ：A5）',
    standardA550: 'A5用紙：52アイテム/ページ',
    standardA560: 'A5用紙：60アイテム/ページ',
    countBarcode: 'バーコード数',
    barcode: 'バーコード',
    setFontsize: 'フォント設定',
    accessPermissionDes: 'ユーザーにアクセス権を割り当てます。',
    deleteUser: 'ユーザー削除の確認',
    confirmDeleteUser: 'ユーザーを削除しますか？',
    passAtless: 'パスワードは6文字以上必要です。',
    inValidPass: 'パスワードが正しくありません',
    createBy: '作成者',
    adjustAutoDes: "システムの自動更新を行わない場合、商品の合計在庫数が正しくなくなる可能性があります。",
    addUser: 'ユーザーを追加',
    isMenu: 'お客様メニューに表示',
    menuSmart: '商品メニューを設定',
    smartSettingTitle: 'メニュー設定',
    smartSetting: 'Silom CRMのメニューを設定',
    confirmEnable: 'メニューを有効にしますか？',
    confirmDisEnable: 'メニューを無効にしますか？',
    confirmSelfOrderEnable: 'セルフオーダーメニューを有効にしますか？',
    confirmSelfOrderDisable: 'セルフオーダーメニューを無効にしますか？',
    enable: '有効',
    disable: '無効',
    usabilityStatus: '有効',
    manageSmartOnProduct: '商品ページでお客様に表示する商品リストの追加/編集ができます。',
    manageSmartOnCategory: 'カテゴリーページでお客様に表示するカテゴリーリストの追加/編集ができます。',
    turnonSmart: 'メニューを有効にする',
    manageShopDes: 'ユーザーマニュアルは以下を参照してください -',
    desSmartMenu: 'E-menuをLINEで表示するための商品メニューを設定し、お客様が簡単にアクセスして商品を注文できるようにします。',
    link: 'リンク',
    createTranferOut: '出庫移動伝票を作成',
    roundingValue: '端数調整',
    limitItems: '商品は最大200アイテムまで選択可能',
    IncomeCategory: '収入',
    ExpenseCategory: '支出',
    saveBy: '保存者',
    saveDate: '保存日',
    drawerCate: 'カテゴリー',
    openingHours: '営業時間',
    shopLocation: '店舗所在地',
    sunday: '日曜日',
    monday: '月曜日',
    tuesday: '火曜日',
    wednesday: '水曜日',
    thursday: '木曜日',
    friday: '金曜日',
    saturday: '土曜日',
    lat: '緯度',
    lng: '経度',
    shopCoverSetting: '店舗カバー設定',
    shopCoverSettingDes: 'お客様画面に表示する店舗カバーを設定',
    locationSettingDes: '所在地設定',
    updatelocation: '所在地を更新',
    searchLocation: '場所を検索',
    imaginaryLine: '仮想線',
    openingHoursDes: '店舗の営業時間を設定',
    paymentDescriptionConfig: 'お支払い方法を選択',
    creditCard: 'クレジットカード',
    promptPay: 'Promptpay',
    coupon: 'クーポン',
    quickpay: 'Krungsri Quick Pay',
    alipay: 'Alipay',
    linepay: 'Rabbit LINE Pay',
    thaidotcom: 'Thai Dot Com Payment',
    mounth: '月',
    dayMY: '日付',
    item: 'アイテム',
    byStockIn: '入庫',
    stockOutOther: 'その他',
    drawerSales: '売上',
    sumIncomeExpenses: '収支概要',
    incomeOther: 'その他の収入',
    loss: '損失',
    grossProfit: '粗利益',
    newUser: '新規ユーザー',
    userType: 'ユーザータイプ',
    password: 'パスワード',
    confirmPassword: 'パスワード確認',
    ParticipatingProducts: '商品を選択',
    descriptionSilomOrder: 'order.silompos.com用の商品を選択',
    cashierManagement: 'レジ管理',
    cashierManageButton: '管理',
    cashierUsernamePassword: 'ユーザー名/パスワード',
    cashierCRUDDescription: 'order.silompos.comログイン用',
    password: 'パスワード',
    placeholderPassword: '6文字以上',
    resetPassword: 'パスワードリセット',
    oldPassword: '旧パスワード',
    oldPasswordPlaceholder: '旧パスワード',
    newPassword: '新しいパスワード',
    purchaseDetail: '購入詳細',
    uploadImage: '画像をアップロード',
    keyword: 'キーワード',
    firstname: '名',
    lastname: '姓',
    province: '都道府県',
    district: '区',
    subdistrict: '町',
    addressNumber: '住所',
    setAsDefaultAddress: 'デフォルト住所に設定',
    setAsTaxAddress: '税務住所に設定',
    setAsShippingAddress: '配送住所に設定',
    contact: '連絡先',
    setAsDefault: 'デフォルトに設定',
    addressLists: '住所一覧',
    default: 'デフォルト',
    taxAddress: '税務請求書',
    shippingAddress: '配送',
    addAddress: '追加',
    createdAt: '作成日',
    updatedAt: '更新日',
    by: '者',
    readyForSale: '販売可能',
    sold: '販売済み',
    delete: '削除',
    items: 'アイテム',
    itemDiscount: '商品割引',
    failedToSave: '保存に失敗しました！',
    dateOfBirth: '生年月日',
    menu: 'メニュー',
    dashboardMenu: 'ダッシュボード',
    transactionMenu: '取引',
    currentBillMenu: '現在の伝票',
    reportMenu: 'レポート',
    orderDeviceMenu: '注文デバイス',
    memberMenu: 'メンバー',
    inventoryMenu: '在庫',
    productMenu: '商品',
    selfOrderMenu: '販売チャネル',
    settingMenu: '設定',
    salesReportByDate: '日付別売上',
    salesReportByBill: '伝票別売上',
    salesQuantitySummaryByProductReport: '商品別売上',
    quantitySummaryByPLUReport: '商品別売上（PLU）',
    nonSellingProduct: '未販売商品',
    salesSummaryByCashierReport: 'レジ担当別売上',
    salesSummaryByCategoryReport: 'カテゴリー別売上',
    paymentReport: '支払い',
    salesTaxReport: '消費税',
    drawerReport: 'ドロワー',
    voidBillReport: '無効伝票',
    timesheetReport: 'タイムシート',
    stockInByListReport: '商品別入庫',
    stockOutByListReport: '商品別出庫',
    nonAdjustStockProductReport: '未調整在庫商品',
    exportProductReport: '商品エクスポート',
    salesSummaryByOrderReport: '注文デバイス別',
    salesSummaryProductByOrderReport: '商品別',
    voidBillByOrderReport: '無効伝票',
    inventoryReport: '在庫レポート',
    inventoryReportByPLU: 'PLU別在庫レポート',
    inventoryReportBySerial: 'Serial No.別在庫レポート',
    stockMovement: '在庫移動',
    stockInDocument: '入庫伝票',
    stockOutDocument: '出庫伝票',
    adjustStockDocument: '在庫調整伝票',
    selfOrder: 'セルフオーダー',
    cashier: 'レジ',
    permission: '権限',
    menuSetting: 'メニュー設定',
    management: {
        txtManagement: '管理',
        user: 'アカウント',
        shopBranch: '店舗と支店',
        productManagement: '商品',
        unitManagement: '単位',
        categorytManagement: 'カテゴリー',
        inventory: '在庫',
        stockIn: '入庫',
        stockOut: '出庫',
        adjustStock: '在庫調整',
        checkStock: '在庫確認',
        stockMovement: '在庫移動',
        transferStock: '在庫移動',
        reportByPLU: 'PLU別在庫レポート',
        reportBySKU: '在庫レポート',
        txtreportBySKU: '在庫レポート',
        txtreportByPLU: 'PLU別在庫レポート',
        stockInDoc: '入庫伝票',
        stockOutDoc: '出庫伝票',
        adjustStockDoc: '在庫調整伝票',
        transferStockDoc: '在庫移動伝票',
        transferStockInDoc: '入庫移動伝票',
        transferStockOutDoc: '出庫移動伝票',
    },
    report: {
        dashboard: 'ダッシュボード',
        transaction: '取引',
        currentbill: '現在の伝票',
        daily: '日付別',
        txtdaily: '日付別売上レポート',
        dailyDes: '日付別売上レポート詳細',
        sellbyProduct: '伝票詳細別',
        txtsellbyProduct: '伝票詳細別売上レポート',
        sku: '商品別',
        txtsku: '商品別売上レポート',
        plu: '商品別（PLU）',
        textPlu: '商品別売上レポート（PLU）',
        paymentreport: '支払いレポート',
        txtpaymentreport: '支払いレポート',
        timesheet: 'タイムシート',
        txtTimesheet: 'タイムシートレポート',
        unsell: '未販売商品',
        txtUnsell: '未販売商品',
        byCategory: 'カテゴリー別',
        txtbyCategory: 'カテゴリー別売上レポート',
        byCashier: 'レジ担当別',
        txtbyCashier: 'レジ担当別売上レポート',
        salesTax: '消費税レポート',
        txtSalesTax: '消費税レポート',
        voidbill: '無効伝票',
        txtvoidbill: '無効伝票レポート',
        closedSale: '売上締め',
        txtCloseSale: 'ドロワーレポート',
        salesByOrder: '売上概要',
        productByOrder: '商品別',
        unsalesByOrder: '無効伝票',
        txtDeliveryRoport: '配送別支払いレポート',
        txtCustomReport: 'カスタム支払いレポート',
        txtSalesByOrder: '注文デバイス別商品売上',
        txtDailyOrder: '注文デバイス別売上レポート',
        txtViodOrder: '注文デバイス別無効伝票',
        nonadjust: '未調整在庫商品',
        txtnonadjust: '未調整在庫商品レポート',
        stockInReport: '商品別入庫レポート',
        stockOutReport: '商品別出庫レポート',
        stockIn: '商品別入庫',
        stockOut: '商品別出庫',
        exportProduct: '商品エクスポート',
        txtExportProduct: '商品エクスポートレポート',
        cashDrawer: 'ドロワー',
        txtCashDrawerr: '現金管理レポート',
        cashRevenue: '現金収入',
    },
    drawer: {
        cashDrawer: 'ドロワー',
        txtCashDrawerr: '現金管理レポート',
        cashRevenue: '収支概要',
        txtcashRevenue: '収支概要レポート',
    },
    member: {
        txtmember: 'メンバー',
        register: '店舗登録（LINE OA）',
        loyaltyPoint: 'ロイヤリティポイント',
        storeCredit: 'ストアクレジット',
        deal: 'ディール',
        giftVoucher: 'ギフトバウチャー',
        referral: '招待',
        crm: 'Silom CRM',
    },
    unableStockDescription: '伝票作成後に在庫が更新されたため、商品を編集できません。',
    noItem: 'アイテムなし',
    enterProductName: '商品名を入力',
    ByCategory: 'カテゴリー別',
    ByCategoryDetail: 'カテゴリー別詳細',
    maximum: '最大',
    selectZone: 'ゾーンを選択',
    minimum: '最小',
    unlimited: '無制限',
    startTime: '開始時間',
    endTime: '終了時間',

    "errorMessages": {
        "qrExpired": "QR Code期限切れ",
        "qrNotFound": "QR Codeが見つかりません",
        "paymentSuccess": "お支払い成功",
        "invalidQrType": "無効なQR Codeタイプ",
        "tableMoved": "テーブルが移動されました",
        "receiptVoided": "レシートが無効化されました"
    },
    "errorDescriptions": {
        "qrExpired": "ご使用のQR Codeは期限切れです。<br>スタッフにお問い合わせください。",
        "qrNotFound": "注文用QR Code情報が見つかりませんでした。<br>スタッフにお問い合わせください。",
        "paymentSuccess": "ご利用ありがとうございます！",
        "invalidQrType": "スタッフに連絡してダイナミックQR Codeを取得してください。",
        "tableMoved": "スタッフに連絡して新しいQR Codeを取得してください。",
        "receiptVoided": "ご利用ありがとうございます。<br>サポートが必要な場合はスタッフにお問い合わせください。"
    },
    waitForServe: '提供待ち',
    DineInPaymentDetails: 'お支払い',
    silomPayProDesp: 'Silom Pay Easyによる安全な決済',
    billDetail: '伝票詳細',
    minute: '分',
    paymentTImeExpired: '時間切れ',
    openApp: 'アプリを開く',
    callPayStaffSuccess: 'スタッフを呼びました<br>お支払い完了までお待ちください',
    account: 'アカウント',
    refNumber: '参照番号',
    QRCodeBBL: 'クレジットカードQR Code',
    trackOrderStatus: '注文状況を追跡',
    all: 'すべて',
    noOrderThisStatus: 'このステータスの注文はありません',
    orderCompleteThanks: 'ご利用ありがとうございます！',
    OnPreparingYourOrder: 'ご注文を準備中...',
    goToTracking: '追跡ページへ',
    "dine-in": '店内飲食',
    typeOfOrder: '注文タイプ',
    queue: '待ち番号',
    cooking: '調理中',
    orderedAt: '注文時間',
    orderTimeStatus: '注文時間',
    acceptTimeStatus: '受付時間',
    estTimeStatus: '予想時間',
    newOrderDelivery: '新規注文',
    acceptOrderDelivery: '注文受付',
    readyToServeDelivery: '提供準備完了',
    orderCompleted: '注文終了',
    orderCanceled: '注文キャンセル',
    readyToShip: '出荷準備完了',
    scanForPayment: 'スキャンしてお支払い',
    orderType: '注文タイプ',
    welcomeBack: "おかえりなさい 👋",
    welcomeBackDespt: "ログインして注文を続けましょう",
    orLoginWith: "または以下でログイン",
    dontHaveAccount: 'アカウントをお持ちでないですか？',
    register: '登録',
    fullName: "氏名",
    fullNameDespt: 'フルネーム',
    emailDespt: 'メールアドレス',
    createPassword: 'パスワードを作成',
    alreadyHaveAccount: 'すでにアカウントをお持ちですか',
    verifyEmail: 'メール認証',
    enterOTPSentTo: 'に送信されたOTPを入力',
    enterSixOTP: '6桁のOTPを入力',
    verifyOTP: 'OTPを認証',
    weWillSentOTPEmail: 'メールにOTPを送信します',
    enterYourEmail: 'メールアドレスを入力',
    confirmNewPassword: '新しいパスワードを確認',
    sendOTP: 'OTPを送信',
    addPhoneNumber: '電話番号を追加',
    addPhoneForRegister: '登録用電話番号を追加',
    enterPhone: '電話番号を入力',
    phoneUsed: '電話番号は既に使用されています',
    emailUsed: 'メールアドレスは既に使用されています',
    enterPassword: 'パスワードを入力',
    registerEmail: '登録済みメール',
    otpInvalid6: "有効な6桁のOTPを入力してください。",
    emailVerified: "メール認証に成功しました！",
    emailOrPasswordInvalid: 'メールまたはパスワードが無効です',
    pleaseEnterEmail: 'メールアドレスを入力してください',
    otpSentToEmail: "メールにOTPを送信しました",
    passwordNotMatch: "パスワードが一致しません",
    resetPasswordCompleted: 'パスワードがリセットされました！',
    failResetPassword: 'パスワードのリセットに失敗しました',
    completePhoneFail: '電話番号の登録に失敗しました',
    plaseEnterValidEmail: '有効なメールアドレスを入力してください',
    invalidPhoneNumber: '電話番号は06、08、または09で始まり、10桁である必要があります',
    example: '例',
    passwordSet: "6文字以上で数字を含む必要があります",
    SelectTableToAdd: 'テーブル',
    availableTable: '利用可能',
    unAvailableTable: '利用不可',
    SelectTableToAddDesp: '店内飲食用のテーブルを選択してください<br>注意：テーブルの変更を希望する場合はスタッフにお問い合わせください',
    updatedStaus: 'ステータスが更新されました',
    otpExpired: 'OTP期限切れ',
    and: "と",
    emailOTP: "メールOTP",
    emailOTPDesp: "メールで受信したOTPを入力してください",
    phoneOTP: "電話OTP",
    phoneOTPDesp: "SMSで受信したOTPを入力してください",
    checkSpamBox: '* メールが届かない場合は、迷惑メールフォルダをご確認ください。到着まで数分かかる場合があります。',
    DineInPaymentPending: '支払い保留中',
    visitProceedPayment: 'お支払いへ進む',
    proceedPayment: "お支払いを続ける",
    proceedPaymentDesp: "この伝票は現在お支払い処理中です。<br>追加注文をする場合は、<br>進行中のお支払いをキャンセルしてください",
    queueIndex: '待ち番号',
    otpSentToPhone: 'SMSでOTPを送信しました。',
    failToSendOTP: 'OTPの送信に失敗しました',
    somethingWentWrong: '問題が発生しました',
    tableHasNoOrder: 'テーブルに注文がありません',
    kbankProceedPaymentDesp: 'この伝票は現在お支払い処理中です。<br>追加注文またはお支払い方法の変更をする場合は、<br>進行中のお支払いをキャンセルしてください'
,
  openHours: '営業',
}

export default messages
